export default __webpack_public_path__ + "static/media/Produkt-Regular.afe2c8cb.woff2";